import React, { useState, useEffect } from 'react';
import BoxWrapper from '../boxwra';
import ConfirmationDialog from '../../../Sales/TDSReconciliationSale/ConfirmationDailog';
import { Snackbar, Alert } from '@mui/material';
import { hexToRgb } from '@material-ui/core';

function Ten({ handleBack, updateTableData, data }) {
  const [tableData, setTableData] = useState(data);
  const [tableName, setTableName] = useState("10, 11, 12 & 13. Particulars of the transactions for the financial year declared in returns of the next financial year till the specified period");
  const [saveDailog, setSaveDailogOpen] = useState(false);
  const [unsavedChanges, setUnsavedChanges] = useState(false);
  const [confirmBack, setConfirmBack] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  // Function to update tableData with calculated values
  const updateTableDataWithCalculations = (currentTableData) => {
    return currentTableData.map((item) => {
      const isSubTotalRow = item.name === "Total turnover (5N +10-11)";
      if (isSubTotalRow) {
        return {
          ...item,
          taxable_value: getSubTotalRowValue(item, 'taxable_value', currentTableData),
          igst: getSubTotalRowValue(item, 'igst', currentTableData),
          cgst: getSubTotalRowValue(item, 'cgst', currentTableData),
          sgst: getSubTotalRowValue(item, 'sgst', currentTableData),
          cess: getSubTotalRowValue(item, 'cess', currentTableData),
        };
      }
      return item;
    });
  };


  const submitHandle = () => {
  // Compute fresh calculated values for the subtotal row before saving
  const dataToSubmit = tableData.map((item) => {
    if (item.name === "Total turnover (5N +10-11)") {
      return {
        ...item,
        taxable_value: getSubTotalRowValue(item, 'taxable_value', tableData),
        igst: getSubTotalRowValue(item, 'igst', tableData),
        cgst: getSubTotalRowValue(item, 'cgst', tableData),
        sgst: getSubTotalRowValue(item, 'sgst', tableData),
        cess: getSubTotalRowValue(item, 'cess', tableData),
      };
    }
    return item; // All other rows remain unchanged
  });

  // Send the complete and accurate data (including calculated totals)
  updateTableData(tableName, dataToSubmit);

  setUnsavedChanges(false);
  setSaveDailogOpen(false);
  setSnackbarOpen(true);
};

  // const submitHandle = () => {
  //   // Update tableData with calculated values before saving
  //   // const updatedTableData = updateTableDataWithCalculations(tableData);
  //   updateTableData(tableName, tableData);
  //   setUnsavedChanges(false);
  //   setSaveDailogOpen(false);
  //   setSnackbarOpen(true);
  // };

  const handleBackButton = () => {
    if (unsavedChanges) {
      setConfirmBack(true);
    } else {
      handleBack();
    }
  };

  const confirmBackHandle = () => {
    submitHandle();
    handleBack();
  };


  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };

  // Helper function to safely parse values for calculations
  const safeParseFloat = (value) => {
    if (!value || value === '' || value === '-') {
      return 0; // Return 0 for incomplete values during typing
    }

    // Convert to string to safely use string methods
    const stringValue = String(value);
    if (stringValue.endsWith('.')) {
      return 0; // Return 0 for incomplete decimal values during typing
    }

    const parsed = parseFloat(value);
    return isNaN(parsed) ? 0 : parsed;
  };


  const formatRupee = (value, isManualInput = false) => {
    // For manual type fields, if value is empty, null, undefined, or 0, return empty string
    if (isManualInput && (!value || value === 0 || value === '0' || value === '0.00')) {
      return '';
    }

    if (!value && value !== 0) return '';

    // Check if the value has decimal places
    const hasDecimal = value.toString().includes('.');
    const decimalPlaces = hasDecimal ? value.toString().split('.')[1]?.length || 0 : 0;

    const formatter = new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: hasDecimal && decimalPlaces > 0 ? Math.min(decimalPlaces, 2) : 0,
      maximumFractionDigits: 2,
    });
    return formatter.format(value).replace('INR', '₹');
  };

  // const formatRupee = (value, isManualInput = false) => {
  //   // For manual input fields, show empty if no value or zero
  //   if (isManualInput && (!value || value === '' || value === '0' || value === '0.00' || parseFloat(value) === 0)) {
  //     return '';
  //   }

  //   // For calculated/subtotal rows, always show formatted value (but empty if no value)
  //   if (!value && value !== 0) return '';

  //   // Only format if there's actually a value
  //   const numValue = parseFloat(value);
  //   if (numValue === 0 && isManualInput) return '';

  //   // For manual input, don't add .00 if it's a whole number
  //   if (isManualInput) {
  //     if (numValue % 1 === 0) {
  //       return `₹${numValue.toString()}`;
  //     } else {
  //       return `₹${numValue.toString()}`;
  //     }
  //   }

  //   return `₹${numValue.toFixed(2)}`;
  // };

  const parseRupee = (value) => {
    if (!value) return '';
    // Allow only digits, one decimal point, and optional leading negative sign
    let cleaned = value.replace(/[^0-9.-]/g, '');
    // Ensure only one decimal point
    const parts = cleaned.split('.');
    if (parts.length > 2) {
      cleaned = parts[0] + '.' + parts.slice(1).join('');
    }
    // Ensure only one negative sign at the beginning
    if (cleaned.startsWith('-')) {
      cleaned = '-' + cleaned.substring(1).replace(/-/g, '');
    } else {
      cleaned = cleaned.replace(/-/g, '');
    }
    return cleaned;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const [itemName, field] = name.split(',');

    // Clean the input value but allow intermediate states like "-", "5.", etc.
    const cleanedValue = parseRupee(value);

    setTableData((prevData) =>
      prevData.map((item) =>
        item.name === itemName
          ? { ...item, [field]: cleanedValue }
          : item
      )
    );

    setUnsavedChanges(true);

    // Force re-render to update calculated subtotals when any manual input changes
    // setTimeout(() => {
    //   setTableData((prev) => [...prev]);
    // }, 0);
  };


const getSubTotalRowValue = (item, key_name, dataToUse = tableData) => {
  let value = 0;
  switch (item.name) {
    case "Total turnover (5N +10-11)":
      const storedTableItemsJSON = localStorage.getItem('tableItems');
      const storedTableItems = storedTableItemsJSON ? JSON.parse(storedTableItemsJSON) : {};
      const fiveN = safeParseFloat(storedTableItems?.five_n?.[key_name] || 0);
      const ten = safeParseFloat(dataToUse[0]?.[key_name] || 0);
      const eleven = safeParseFloat(dataToUse[1]?.[key_name] || 0);
      value = fiveN + ten - eleven;

      // LOG ONLY ONCE: When key_name is 'taxable_value'
      if (key_name === 'taxable_value') {
        console.log("1777 ------?", fiveN, ten, eleven);
      }

      break;
    default:
      value = 0;
  }
  return value.toFixed(2);
};

  // const getSubTotalRowValue = (item, key_name, dataToUse = tableData) => {
  //   let value = 0;
  //   switch (item.name) {
  //     case "Total turnover (5N +10-11)":
  //       const storedTableItemsJSON = localStorage.getItem('tableItems');
  //       const storedTableItems = storedTableItemsJSON ? JSON.parse(storedTableItemsJSON) : {};
  //       const fiveN = safeParseFloat(storedTableItems?.five_n?.[key_name] || 0);
  //       const ten = safeParseFloat(dataToUse[0]?.[key_name] || 0);
  //       const eleven = safeParseFloat(dataToUse[1]?.[key_name] || 0);
  //       value = fiveN + ten - eleven;
  //       console.log("1777 ------?",fiveN, ten, eleven);
        
  //       break;
  //     default:
  //       value = 0;
  //   }
  //   return value.toFixed(2);
  // };

  const renderTableRows = () => {
    const getRowColor = (index) => {
      const colors = ['#e0e7ff', '#e9d5ff', '#f3e8ff', '#ede9fe', '#ddd6fe'];
      return colors[index % colors.length];
    };

    return tableData.map((item, index) => {
      const isSubTotalRow = item.name === "Total turnover (5N +10-11)";
      const isManualInputRow = !isSubTotalRow && (item.manual_type !== false);
      const isRow3or4 = index === 2 || index === 3;

      return (
        <div
          key={index}
          style={{
            display: 'grid',
            gridTemplateColumns: '60px 1fr 150px 150px 150px 150px 150px',
            gap: '10px',
            alignItems: 'center',
            padding: '8px 10px',
            borderBottom: '1px solid #f1f5f9',
            backgroundColor: index % 2 === 0 ? '#ffffff' : '#f8fafc',
            borderRadius: '6px',
            marginBottom: '2px',
            minHeight: '50px',
          }}
        >
          <span
            style={{
              color: '#1e293b',
              fontSize: '13px',
              fontWeight: '600',
              textAlign: 'center',
              padding: '8px 6px',
              backgroundColor: getRowColor(index),
              borderRadius: '6px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {index + 1}
          </span>
          <span
            style={{
              color: '#334155',
              fontSize: '13px',
              padding: '8px 12px',
              backgroundColor: '#f1f5f9',
              borderRadius: '6px',
              wordBreak: 'break-word',
              textAlign: 'left',
              display: 'flex',
              alignItems: 'center',
              minHeight: '34px',
            }}
          >
            {item.name}
          </span>
          {['taxable_value', 'igst', 'cgst', 'sgst', 'cess'].map((field, idx) => {
            // Check if taxable_value field should be non-editable for rows 3 and 4
            const isTaxableValueRow3or4 = isRow3or4 && field === 'taxable_value';

            // For editable fields, show raw value during editing; for display, format if valid number
            let displayValue;
            if (isTaxableValueRow3or4) {
              // Don't fetch or display values for taxable_value in rows 3 and 4
              displayValue = '';
            } else if (isSubTotalRow) {
              displayValue = formatRupee(getSubTotalRowValue(item, field));
            } else if (isManualInputRow) {
              const rawVal = item[field];
              const numVal = safeParseFloat(rawVal);
              // Convert to string to safely use string methods
              const stringVal = String(rawVal || '');
              displayValue = (rawVal === '' || rawVal === '-' || stringVal.endsWith('.')) ? rawVal : formatRupee(numVal, true);
            } else {
              displayValue = formatRupee(item[field], isManualInputRow) || '';
            }

            return (
              <input
                key={`${item.name},${field}`}
                type="text"
                className="blue-color"
                name={`${item.name},${field}`}
                value={displayValue}
                onChange={handleInputChange}
                readOnly={isSubTotalRow || !isManualInputRow || isTaxableValueRow3or4}
                style={{
                  color: '#1e293b',
                  fontWeight: '500',
                  fontSize: '13px',
                  textAlign: 'right',
                  padding: '8px 12px',
                  backgroundColor:
                    isTaxableValueRow3or4
                      ? '#bbb8b8ff'
                      : (isSubTotalRow || !isManualInputRow ? '#f0f0f0' : '#ecfdf5'),
                  // backgroundColor: isSubTotalRow || !isManualInputRow || isTaxableValueRow3or4 ? '#f0f0f0' : '#ecfdf5',
                  border: '1px solid #e2e8f0',
                  borderRadius: '6px',
                  outline: 'none',
                  cursor: isSubTotalRow || !isManualInputRow || isTaxableValueRow3or4 ? 'not-allowed' : 'text',
                  minHeight: '34px',
                  boxSizing: 'border-box',
                  width: '100%',
                  ...(isSubTotalRow ? { fontWeight: 'bold', borderColor: 'green', borderWidth: '2px' } : {}),
                }}
                onFocus={(e) => {
                  if (!isSubTotalRow && isManualInputRow && !isTaxableValueRow3or4) {
                    // On focus, show raw value without formatting for easier editing
                    const rawVal = item[field] || '';
                    e.target.value = rawVal;
                    e.target.style.borderColor = '#88d8a3';
                    e.target.style.boxShadow = '0 0 0 2px rgba(136, 216, 163, 0.1)';
                  }
                }}
                onBlur={(e) => {
                  if (!isSubTotalRow && isManualInputRow && !isTaxableValueRow3or4) {
                    // On blur, re-format the value if it's a valid number
                    const rawVal = e.target.value;
                    const cleanedVal = parseRupee(rawVal);
                    const numVal = safeParseFloat(cleanedVal);
                    // Convert to string to safely use string methods
                    const stringVal = String(cleanedVal || '');
                    const finalDisplay = (cleanedVal === '' || cleanedVal === '-' || stringVal.endsWith('.')) ? cleanedVal : formatRupee(numVal, true);
                    e.target.value = finalDisplay;
                    // Update state with cleaned value
                    setTableData((prevData) =>
                      prevData.map((it) =>
                        it.name === item.name
                          ? { ...it, [field]: cleanedVal }
                          : it
                      )
                    );
                    e.target.style.borderColor = '#e2e8f0';
                    e.target.style.boxShadow = 'none';
                  }
                }}
              />
            );
          })}
        </div>
      );
    });
  };

  // Debug logging
  useEffect(() => {
    console.log('Ten tableData updated:', tableData);
  }, [tableData]);

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: '20px',
          padding: '30px',
          width: '100%',
          boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
        }}
      >
        <BoxWrapper
          backButtonForZohoEnable={true}
          backButton={handleBackButton}
          boxTitle={tableName}
        >
          <p style={{ marginLeft: '10px' }}>
            <span style={{ fontWeight: 'bold' }}>Note: </span> The fields where the system computed values would be modified by more/less 20% shall be highlighted in <span style={{ color: 'red' }}>Red</span> for reference and attention.
          </p>
          <hr style={{ marginLeft: '10px' }} />
        </BoxWrapper>

        <div
          style={{
            maxHeight: 'calc(100vh - 450px)',
            overflowY: 'auto',
            marginTop: '10px',
          }}
        >
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '60px 1fr 150px 150px 150px 150px 150px',
              gap: '10px',
              alignItems: 'center',
              padding: '8px 10px',
              borderBottom: '2px solid #e2e8f0',
              backgroundColor: '#f8fafc',
              borderRadius: '6px',
              marginBottom: '2px',
              minHeight: '50px',
              fontWeight: '600',
              color: '#475569',
              fontSize: '13px',
              position: 'sticky',
              top: '0',
              zIndex: '10',
            }}
          >
            <span
              style={{
                textAlign: 'center',
                padding: '8px 6px',
                backgroundColor: '#e0e7ff',
                borderRadius: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              S.No.
            </span>
            <span
              style={{
                textAlign: 'left',
                padding: '8px 12px',
                backgroundColor: '#f1f5f9',
                borderRadius: '6px',
                wordBreak: 'break-word',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              Description
            </span>
            <span
              style={{
                textAlign: 'right',
                padding: '8px 12px',
                backgroundColor: '#f1f5f9',
                borderRadius: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
              }}
            >
              Taxable Value (₹)
            </span>
            <span
              style={{
                textAlign: 'right',
                padding: '8px 12px',
                backgroundColor: '#f1f5f9',
                borderRadius: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
              }}
            >
              Integrated Tax (₹)
            </span>
            <span
              style={{
                textAlign: 'right',
                padding: '8px 12px',
                backgroundColor: '#f1f5f9',
                borderRadius: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
              }}
            >
              Central Tax (₹)
            </span>
            <span
              style={{
                textAlign: 'right',
                padding: '8px 12px',
                backgroundColor: '#f1f5f9',
                borderRadius: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
              }}
            >
              State/UT Tax (₹)
            </span>
            <span
              style={{
                textAlign: 'right',
                padding: '8px 12px',
                backgroundColor: '#f1f5f9',
                borderRadius: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
              }}
            >
              CESS (₹)
            </span>
          </div>
          {tableData && tableData.length >= 1 ? renderTableRows() : (
            <div style={{ textAlign: 'center', color: '#64748b', padding: '20px' }}>
              No Data Found!
            </div>
          )}
        </div>

        <div
          style={{
            marginTop: '20px',
            padding: '15px',
            backgroundColor: '#f8fafc',
            borderRadius: '8px',
            borderTop: '2px solid #e2e8f0',
          }}
        >
          <p style={{ margin: '0', fontSize: '14px', color: '#64748b', textAlign: 'center' }}>
            Total Records: {tableData?.length || 0}
          </p>
        </div>

        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: '20px',
            gap: '10px',
          }}
        >
          <button
            type="button"
            className="button-primary"
            onClick={() => setSaveDailogOpen(true)}
            style={{
              padding: '10px 20px',
              background: 'linear-gradient(135deg, #ffd3a5 0%, #fd9853 50%, #e8a87c 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              fontSize: '14px',
              fontWeight: '600',
              cursor: 'pointer',
              boxShadow: '0 4px 12px rgba(255, 211, 165, 0.3)',
              transition: 'all 0.2s ease',
            }}
            onMouseOver={(e) => {
              e.target.style.transform = 'translateY(-1px)';
              e.target.style.boxShadow = '0 6px 16px rgba(255, 211, 165, 0.4)';
            }}
            onMouseOut={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 12px rgba(255, 211, 165, 0.3)';
            }}
          >
            Save
          </button>
          {/* <button
            type="button"
            className="button-primary"
            style={{
              padding: '10px 20px',
              background: 'linear-gradient(135deg, #ffd3a5 0%, #fd9853 50%, #e8a87c 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              fontSize: '14px',
              fontWeight: '600',
              cursor: 'pointer',
              boxShadow: '0 4px 12px rgba(255, 211, 165, 0.3)',
              transition: 'all 0.2s ease',
            }}
            onMouseOver={(e) => {
              e.target.style.transform = 'translateY(-1px)';
              e.target.style.boxShadow = '0 6px 16px rgba(255, 211, 165, 0.4)';
            }}
            onMouseOut={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 12px rgba(255, 211, 165, 0.3)';
            }}
          >
            Cancel
          </button> */}
        </div>
      </div>

      <ConfirmationDialog
        open={saveDailog}
        onClose={() => setSaveDailogOpen(false)}
        onConfirm={submitHandle}
        title="Confirm Save"
        text="Do you want to save your changes? This action will update the current data."
      />

      <ConfirmationDialog
        open={confirmBack}
        onConfirm={confirmBackHandle}
        onClose={() => handleBack()}
        title="Unsaved Changes"
        text="You have unsaved changes. Do you want to leave without saving?"
      />

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000} // Auto-close after 3 seconds
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity="success"
          sx={{ width: '100%' }}
        >
          Data saved successfully!
        </Alert>
      </Snackbar>
    </div>
  );
}

export default Ten;

